<script setup lang="ts">
import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';
const { height: windowHeight } = useWindowSize();

withDefaults(
  defineProps<{
    message?: string;
    heading?: string;
    customHeight?: string;
    faIcon?: string;
    isFullPage?: boolean;
    icon?: string;
    secondaryMessage?: string;
  }>(),
  {
    icon: 'pi-inbox',
    isFullPage: false,
    message: 'components.dataTable.emptyMessages.emptyMessage',
  }
);

const scrollHeight = computed(() => {
  const topNavHeight = 48;
  const header = 138;
  const bodyPadding = 16;
  const paginator = 45;
  const bottomPaddingCut = 0;

  const elementsHeight = topNavHeight + header + bodyPadding + paginator + bottomPaddingCut;

  const calcHeight = windowHeight.value - elementsHeight;

  return `${calcHeight}px`;
});
</script>

<template>
  <div
    :class="[
      'flex flex-col items-center justify-center gap-3 text-center text-slate-400',
      isFullPage ? ' h-screen' : '',
    ]"
    :style="{ 'max-height': customHeight || scrollHeight }"
  >
    <i
      v-if="!faIcon"
      :class="['pi mb-2 text-center text-2xl', icon]"
    ></i>

    <FaIcon
      v-else-if="faIcon"
      class="mb-2 text-center text-2xl"
      :icon="$icons[faIcon]"
    />

    <div class="flex max-w-sm flex-col gap-2">
      <p
        v-if="heading"
        class="text-2xl"
      >
        {{ $t(heading) }}
      </p>

      <p v-if="message">{{ $t(message) }}</p>

      <p v-if="secondaryMessage">{{ $t(secondaryMessage) }}</p>
    </div>

    <slot name="button" />
  </div>
</template>
